import { render } from "./ScrollLink.vue?vue&type=template&id=8b4475c0&scoped=true"
import script from "./ScrollLink.vue?vue&type=script&lang=js"
export * from "./ScrollLink.vue?vue&type=script&lang=js"

import "./ScrollLink.vue?vue&type=style&index=0&id=8b4475c0&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4475c0"]])

export default __exports__